import { ArrowLeft, EyeVisible } from '@factorialco/f0-react/icons/app'
import { FormFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  form: FormFragment
}

export const buildTrainingFormEditHeaderProps = (data: Props) => {
  const form = data?.form

  if (!form) {
    return {
      title: i18n.t('trainings.surveys.fallback_title'),
    }
  }

  return {
    title: form.title,
    primaryAction: {
      key: 'save',
      label: i18n.t('common.save'),
    },
    secondaryActions: [
      {
        key: 'back',
        icon: ArrowLeft,
        label: i18n.t('trainings.surveys.create.overview'),
      },
      {
        key: 'preview',
        icon: EyeVisible,
        label: i18n.t('trainings.surveys.create.preview'),
      },
    ],
  }
}
